import React, { FunctionComponent } from 'react';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconHome: FunctionComponent<BrassIconProps> = (props: BrassIconProps) => (
  <BrassIcon {...props} icon={faHome} />
);

export { BrassIconHome };
